// extracted by mini-css-extract-plugin
export default {"pm-info-btn":"Questions_pm-info-btn__MJlsq","reason":"Questions_reason__nu0Lx","finalSubmitCheckbox":"Questions_finalSubmitCheckbox__E4gch"};